// components/charts/BarChart.jsx
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';

export function CustomBarChart({ 
  data, 
  title, 
  orientation = 'vertical', 
  color = "#017971",
  showLegend = false 
}) {
  const isVertical = orientation === 'vertical';
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              layout={isVertical ? 'vertical' : 'horizontal'}
            >
              <CartesianGrid strokeDasharray="3 3" />
              {isVertical ? (
                <>
                  <XAxis type="number" />
                  <YAxis type="category" dataKey="name" width={100} />
                </>
              ) : (
                <>
                  <XAxis dataKey="name" />
                  <YAxis />
                </>
              )}
              <Tooltip />
              {showLegend && <Legend />}
              <Bar 
                dataKey="value" 
                fill={color} 
                radius={[4, 4, 0, 0]}
                name={title}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}